import { object, string } from 'yup'

export function normalizeQuizMobile(value: string): string {
  return value.replace(/[\s()-]/g, '').replace(/^(?:\+61|61)(?=4)/, '0')
}

export const billingDetailsSchema = object({
  firstName: string()
    .trim()
    .default('')
    .max(40, 'First name must be 40 characters or fewer.')
    .required('Please enter your first legal name.'),
  lastName: string()
    .trim()
    .default('')
    .max(40, 'Last name must be 40 characters or fewer.')
    .required('Please enter your last legal name.'),
  mobile: string()
    .default('')
    .transform(normalizeQuizMobile)
    .required('Please enter your mobile number.')
    .matches(/^04\d{8}$/, {
      excludeEmptyString: true,
      message: 'Enter an Australian mobile number starting with 04 or +61 4.',
    }),
  formattedAddress: string()
    .trim()
    .default('')
    .required('Please enter your street address.'),
  suburb: string().trim().default('').required('Please enter your suburb.'),
  state: string().default('').required('Please choose your state.'),
  postcode: string()
    .trim()
    .default('')
    .required('Please enter your postcode.')
    .matches(/^\d{4}$/, {
      excludeEmptyString: true,
      message: 'Postcode must contain exactly 4 numbers.',
    }),
})
